import { useState } from 'react';
import { ArrowRight, Package, MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '918880331224';

const categories = ['All', 'Cement', 'Steel', 'Bricks & Blocks', 'Sand & Aggregate', 'Tiles & Flooring', 'Paints', 'Plumbing', 'Electrical'];

const materials = [
  // Cement
  {
    id: 1,
    name: 'UltraTech Cement',
    category: 'Cement',
    description: 'Premium quality OPC 53 grade cement for strong foundations',
    unit: 'per bag (50kg)',
    image: 'https://images.pexels.com/photos/29519165/pexels-photo-29519165.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    featured: true,
  },
  {
    id: 2,
    name: 'ACC Cement',
    category: 'Cement',
    description: 'High-performance cement for all construction needs',
    unit: 'per bag (50kg)',
    image: 'https://images.pexels.com/photos/29817952/pexels-photo-29817952.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    featured: false,
  },
  {
    id: 3,
    name: 'Ambuja Cement',
    category: 'Cement',
    description: 'Trusted cement brand for residential construction',
    unit: 'per bag (50kg)',
    image: 'https://images.unsplash.com/photo-1681880511033-b9582a379ce2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxzYW5kJTIwZ3JhdmVsJTIwY29uc3RydWN0aW9uJTIwYWdncmVnYXRlfGVufDB8fHx8MTc3MjAxNDk2MHww&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  // Steel
  {
    id: 4,
    name: 'TMT Steel Bars',
    category: 'Steel',
    description: 'Fe-500D grade TMT bars for RCC construction',
    unit: 'per kg',
    image: 'https://images.unsplash.com/photo-1761479867761-7a8b11f54449?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxzdGVlbCUyMHJvZHMlMjBjb25zdHJ1Y3Rpb24lMjBidWlsZGluZ3xlbnwwfHx8fDE3NzIwMTQ5NTR8MA&ixlib=rb-4.1.0&q=85',
    featured: true,
  },
  {
    id: 5,
    name: 'Binding Wire',
    category: 'Steel',
    description: 'High-quality galvanized binding wire',
    unit: 'per kg',
    image: 'https://images.unsplash.com/photo-1768926968986-a88590ce5025?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMHJvZHMlMjBjb25zdHJ1Y3Rpb24lMjBidWlsZGluZ3xlbnwwfHx8fDE3NzIwMTQ5NTR8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  // Bricks & Blocks
  {
    id: 6,
    name: 'Red Clay Bricks',
    category: 'Bricks & Blocks',
    description: 'Traditional red clay bricks for wall construction',
    unit: 'per 1000 pcs',
    image: 'https://images.unsplash.com/photo-1705214289208-ec900f8d8d35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBtYXRlcmlhbHMlMjBjZW1lbnQlMjBicmlja3MlMjBzdGVlbHxlbnwwfHx8fDE3NzIwMTQ5NDh8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 7,
    name: 'AAC Blocks',
    category: 'Bricks & Blocks',
    description: 'Lightweight autoclaved aerated concrete blocks',
    unit: 'per piece',
    image: 'https://images.unsplash.com/photo-1716839150167-65bab9a253db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBtYXRlcmlhbHMlMjBjZW1lbnQlMjBicmlja3MlMjBzdGVlbHxlbnwwfHx8fDE3NzIwMTQ5NDh8MA&ixlib=rb-4.1.0&q=85',
    featured: true,
  },
  {
    id: 8,
    name: 'Fly Ash Bricks',
    category: 'Bricks & Blocks',
    description: 'Eco-friendly fly ash bricks with superior strength',
    unit: 'per 1000 pcs',
    image: 'https://images.unsplash.com/photo-1716839134585-04345d8c7c6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjBtYXRlcmlhbHMlMjBjZW1lbnQlMjBicmlja3MlMjBzdGVlbHxlbnwwfHx8fDE3NzIwMTQ5NDh8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  // Sand & Aggregate
  {
    id: 9,
    name: 'River Sand',
    category: 'Sand & Aggregate',
    description: 'Fine quality river sand for plastering and masonry',
    unit: 'per cubic ft',
    image: 'https://images.unsplash.com/photo-1681880511033-b9582a379ce2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxzYW5kJTIwZ3JhdmVsJTIwY29uc3RydWN0aW9uJTIwYWdncmVnYXRlfGVufDB8fHx8MTc3MjAxNDk2MHww&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 10,
    name: 'M-Sand',
    category: 'Sand & Aggregate',
    description: 'Manufactured sand as alternative to river sand',
    unit: 'per cubic ft',
    image: 'https://images.unsplash.com/photo-1760131185787-597c462d6196?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxjZW1lbnQlMjBiYWdzJTIwY29uY3JldGUlMjBwb3dkZXJ8ZW58MHx8fHwxNzcyMDE0OTU1fDA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 11,
    name: 'Stone Aggregate',
    category: 'Sand & Aggregate',
    description: '20mm crushed stone aggregate for concrete',
    unit: 'per cubic ft',
    image: 'https://images.unsplash.com/photo-1649796877686-847d6bdeea6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxzYW5kJTIwZ3JhdmVsJTIwY29uc3RydWN0aW9uJTIwYWdncmVnYXRlfGVufDB8fHx8MTc3MjAxNDk2MHww&ixlib=rb-4.1.0&q=85',
    featured: true,
  },
  // Tiles & Flooring
  {
    id: 12,
    name: 'Vitrified Tiles',
    category: 'Tiles & Flooring',
    description: 'Premium polished vitrified tiles for flooring',
    unit: 'per sq.ft',
    image: 'https://images.pexels.com/photos/3847503/pexels-photo-3847503.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    featured: true,
  },
  {
    id: 13,
    name: 'Ceramic Wall Tiles',
    category: 'Tiles & Flooring',
    description: 'Designer ceramic tiles for bathroom and kitchen',
    unit: 'per sq.ft',
    image: 'https://images.unsplash.com/photo-1647102256335-7a7370d99924?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHx0aWxlcyUyMGZsb29yaW5nJTIwbWFyYmxlJTIwY2VyYW1pY3xlbnwwfHx8fDE3NzIwMTQ5NjF8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 14,
    name: 'Marble Flooring',
    category: 'Tiles & Flooring',
    description: 'Italian marble for luxury flooring solutions',
    unit: 'per sq.ft',
    image: 'https://images.pexels.com/photos/11285332/pexels-photo-11285332.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    featured: false,
  },
  // Paints
  {
    id: 15,
    name: 'Asian Paints Apex',
    category: 'Paints',
    description: 'Premium exterior emulsion paint for weather protection',
    unit: 'per litre',
    image: 'https://images.pexels.com/photos/1887946/pexels-photo-1887946.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    featured: true,
  },
  {
    id: 16,
    name: 'Wall Primer',
    category: 'Paints',
    description: 'White cement based wall primer for smooth finish',
    unit: 'per litre',
    image: 'https://images.pexels.com/photos/5495064/pexels-photo-5495064.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    featured: false,
  },
  {
    id: 21,
    name: 'Interior Emulsion',
    category: 'Paints',
    description: 'Smooth interior wall paint with excellent coverage',
    unit: 'per litre',
    image: 'https://images.unsplash.com/photo-1652572036885-b5e9205dd847?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxjb2xvcmZ1bCUyMHBhaW50JTIwY2FucyUyMGJ1Y2tldHMlMjBkZWNvcmF0aW5nJTIwaG9tZXxlbnwwfHx8fDE3NzI4MDcwMzN8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 22,
    name: 'Berger Weathercoat',
    category: 'Paints',
    description: 'Long-lasting exterior paint with anti-algal properties',
    unit: 'per litre',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxwYWludCUyMGJ1Y2tldCUyMGNvbG9yfGVufDB8fHx8MTY5NTA5MzI4M3ww&ixlib=rb-4.0.3&q=85',
    featured: false,
  },
  {
    id: 23,
    name: 'Nerolac Excel',
    category: 'Paints',
    description: 'Premium acrylic exterior emulsion with dust resistance',
    unit: 'per litre',
    image: 'https://images.unsplash.com/photo-1608556984766-105e2dc59706?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxjb2xvcmZ1bCUyMHBhaW50JTIwY2FucyUyMGJ1Y2tldHMlMjBkZWNvcmF0aW5nJTIwaG9tZXxlbnwwfHx8fDE3NzI4MDcwMzN8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 24,
    name: 'Texture Paint',
    category: 'Paints',
    description: 'Decorative textured wall finish for accent walls',
    unit: 'per kg',
    image: 'https://images.unsplash.com/photo-1572596116404-98f227c01ac1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHx0aWxlcyUyMGZsb29yaW5nJTIwbWFyYmxlJTIwY2VyYW1pY3xlbnwwfHx8fDE3NzIwMTQ5NjF8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 25,
    name: 'Wood Polish',
    category: 'Paints',
    description: 'Premium wood finish polish for doors and furniture',
    unit: 'per litre',
    image: 'https://images.unsplash.com/photo-1604589977707-d161da2edb0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHx0aWxlcyUyMGZsb29yaW5nJTIwbWFyYmxlJTIwY2VyYW1pY3xlbnwwfHx8fDE3NzIwMTQ5NjF8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 26,
    name: 'Waterproof Coating',
    category: 'Paints',
    description: 'Waterproofing paint for terrace and bathroom walls',
    unit: 'per kg',
    image: 'https://images.unsplash.com/photo-1734602012334-6e4bd7a389c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHx0aWxlcyUyMGZsb29yaW5nJTIwbWFyYmxlJTIwY2VyYW1pY3xlbnwwfHx8fDE3NzIwMTQ5NjF8MA&ixlib=rb-4.1.0&q=85',
    featured: true,
  },
  // Plumbing
  {
    id: 17,
    name: 'CPVC Pipes',
    category: 'Plumbing',
    description: 'Hot and cold water CPVC piping system',
    unit: 'per ft',
    image: 'https://images.unsplash.com/photo-1768742118995-191a71110ec9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxzdGVlbCUyMHJvZHMlMjBjb25zdHJ1Y3Rpb24lMjBidWlsZGluZ3xlbnwwfHx8fDE3NzIwMTQ5NTR8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 18,
    name: 'PVC Pipes',
    category: 'Plumbing',
    description: 'Drainage and sewage PVC pipes',
    unit: 'per ft',
    image: 'https://images.pexels.com/photos/6473984/pexels-photo-6473984.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    featured: false,
  },
  // Electrical
  {
    id: 19,
    name: 'Electrical Wires',
    category: 'Electrical',
    description: 'FR grade copper wires for house wiring',
    unit: 'per meter',
    image: 'https://images.unsplash.com/photo-1604589977707-d161da2edb0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHx0aWxlcyUyMGZsb29yaW5nJTIwbWFyYmxlJTIwY2VyYW1pY3xlbnwwfHx8fDE3NzIwMTQ5NjF8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
  {
    id: 20,
    name: 'MCB & Switches',
    category: 'Electrical',
    description: 'Premium switches and circuit breakers',
    unit: 'per piece',
    image: 'https://images.unsplash.com/photo-1734602012334-6e4bd7a389c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHx0aWxlcyUyMGZsb29yaW5nJTIwbWFyYmxlJTIwY2VyYW1pY3xlbnwwfHx8fDE3NzIwMTQ5NjF8MA&ixlib=rb-4.1.0&q=85',
    featured: false,
  },
];

export default function Materials() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredMaterials = activeCategory === 'All' 
    ? materials 
    : materials.filter(m => m.category === activeCategory);

  const handleGetQuote = (materialName) => {
    const message = encodeURIComponent(`Hello! I am interested in getting a quote for "${materialName}". Please share the best price and availability.`);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  const handleBulkQuote = () => {
    const message = encodeURIComponent(`Hello! I need a bulk quote for construction materials. Please contact me for the requirements.`);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <div className="noise-overlay pt-24" data-testid="materials-page">
      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="max-w-3xl">
            <span className="text-[#C9A646] text-xs uppercase tracking-[0.2em] font-bold">
              Quality Materials
            </span>
            <h1 className="font-heading text-4xl md:text-6xl text-white mt-4 font-bold">
              Construction<br />
              <span className="text-[#C9A646]">Materials</span>
            </h1>
            <p className="text-gray-400 text-base mt-6 leading-relaxed">
              Premium quality construction materials at competitive prices. 
              From cement to tiles, we supply everything you need for your project.
            </p>
            <button
              onClick={handleBulkQuote}
              className="mt-8 btn-primary inline-flex items-center gap-2"
              data-testid="bulk-quote-btn"
            >
              <MessageCircle size={20} />
              Get Bulk Quote on WhatsApp
            </button>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-[#f5f5f5] border-y border-gray-200 sticky top-20 md:top-24 z-30">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
            <Package size={20} className="text-[#C9A646] flex-shrink-0" />
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-5 py-2.5 text-sm font-medium whitespace-nowrap transition-all rounded-xl ${
                  activeCategory === category
                    ? 'bg-gradient-to-r from-[#C9A646] to-[#E6C36A] text-[#0A0A0A] shadow-lg shadow-[#C9A646]/30'
                    : 'bg-white text-gray-600 hover:text-gray-900 border border-gray-200 shadow-md shadow-gray-300/50'
                }`}
                data-testid={`filter-${category.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Materials Grid */}
      <section className="py-16 md:py-20 bg-[#f5f5f5]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredMaterials.map((material) => (
              <div
                key={material.id}
                className={`group relative bg-white border border-gray-200 overflow-hidden rounded-2xl hover:border-[#C9A646]/50 hover:shadow-lg transition-all duration-200 ${
                  material.featured ? 'ring-2 ring-[#C9A646]/30' : ''
                }`}
                data-testid={`material-${material.id}`}
              >
                {/* Featured Badge */}
                {material.featured && (
                  <div className="absolute top-4 left-4 z-10 bg-[#C9A646] text-white text-xs font-bold px-3 py-1 rounded-full">
                    Popular
                  </div>
                )}
                
                {/* Image */}
                <div className="relative h-44 overflow-hidden">
                  <img 
                    src={material.image}
                    alt={material.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                </div>
                
                {/* Content */}
                <div className="p-4">
                  <span className="text-[#C9A646] text-xs uppercase tracking-wider font-semibold">
                    {material.category}
                  </span>
                  <h3 className="font-heading text-lg text-gray-900 mt-1 font-bold">
                    {material.name}
                  </h3>
                  <p className="text-gray-600 text-sm mt-2 line-clamp-2">
                    {material.description}
                  </p>
                  <p className="text-gray-500 text-xs mt-2">
                    Price: {material.unit}
                  </p>
                  
                  {/* CTA Button */}
                  <button
                    onClick={() => handleGetQuote(material.name)}
                    className="mt-4 w-full bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white font-semibold py-2.5 px-4 rounded-xl flex items-center justify-center gap-2 hover:opacity-90 transition-opacity"
                    data-testid={`quote-btn-${material.id}`}
                  >
                    <MessageCircle size={16} />
                    Get Quote
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filteredMaterials.length === 0 && (
            <div className="text-center py-16">
              <p className="text-gray-500 text-lg">No materials found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16 md:py-24 bg-[#ececec] border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <span className="text-[#C9A646] text-xs uppercase tracking-[0.2em] font-bold">
              Why Choose Us
            </span>
            <h2 className="font-heading text-4xl md:text-5xl text-gray-900 mt-4">
              Your Trusted Material Partner
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { title: 'Best Prices', desc: 'Competitive wholesale rates on all materials' },
              { title: 'Quality Assured', desc: 'Only branded and certified products' },
              { title: 'Fast Delivery', desc: 'Quick delivery to your construction site' },
              { title: 'Bulk Orders', desc: 'Special discounts on bulk purchases' },
            ].map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white/50 border border-gray-200 p-6 text-center rounded-2xl hover:border-[#C9A646]/30 transition-colors shadow-lg shadow-gray-300/50"
              >
                <h3 className="font-heading text-xl text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm mt-2">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-gradient-to-r from-[#25D366] to-[#128C7E]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="font-heading text-4xl md:text-5xl text-gray-900">
              Need Construction Materials?
            </h2>
            <p className="text-gray-900/80 text-lg mt-4">
              Get instant quotes on WhatsApp. We deliver to Kalaburagi & surrounding areas.
            </p>
            <button
              onClick={handleBulkQuote}
              className="mt-8 bg-white text-[#128C7E] font-bold px-10 py-5 rounded-xl hover:bg-gray-100 transition-colors inline-flex items-center gap-2 shadow-lg"
              data-testid="materials-cta-btn"
            >
              <MessageCircle size={22} />
              WhatsApp Us Now
              <ArrowRight size={20} />
            </button>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
